import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';

// script-loader! makes it available globally.
import 'script-loader!jquery/dist/jquery.min.js'
import 'script-loader!popper.js/dist/umd/popper.min.js';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js'

import 'script-loader!./scripts.js';

import "../sass/index.scss";